import { render, staticRenderFns } from "./ThemeName.vue?vue&type=template&id=9ddc6450&"
import script from "./ThemeName.vue?vue&type=script&lang=js&"
export * from "./ThemeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ddc6450')) {
      api.createRecord('9ddc6450', component.options)
    } else {
      api.reload('9ddc6450', component.options)
    }
    module.hot.accept("./ThemeName.vue?vue&type=template&id=9ddc6450&", function () {
      api.rerender('9ddc6450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/ThemeName.vue"
export default component.exports